module.exports = __webpack_public_path__ + "img/9.e18c9659.jpg";